var $ = require("jquery");
var lightbox2 = require('lightbox2');
$(function(){

  function desktop() {
    var $tip = $('.js-tip');
    $tip.hover(function(){
      var $parent = $(this).parents('.js-parent');
      var $item = $parent.children('.js-dw__item');
      $item.each(function(){
        $(this).children().removeClass('active');
      });
      $(this).addClass('active');
      var $thumbnail = $(this).children('.js-tip__thumbnail');
      $thumbnail.stop().fadeIn(200);
      $thumbnail_url = $thumbnail.children().attr('src');
      $dw_img = $thumbnail_url.replace('_t0','_p0');
      $(this).parents('.dw').children().children('img').attr('src', $dw_img);
    }, function(){
      $(this).children('.js-tip__thumbnail').stop().fadeOut(200);
    });
  }

  function mobile() {
    $('.js-tip__thumbnail img').each(function(){
      var thum_url = $(this).attr('src');
      var pic_url = thum_url.replace('_t','_p');
      $(this).wrap('<a data-lightbox="roadtrip" href="' + pic_url + '"></a>');
    });
  }


  $(window).on('load orientationchange', function(){
    width = $(window).width();
    bp = '769';
    if(width > bp || Math.abs(window.orientation) === 90 ) {
      desktop();
    } else {
      mobile();
    }
  });
});

